(function(){'use strict';function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}var CareerSection=function(){function e(i){_classCallCheck(this,e),this.container=i,this.cards=Array.from(i.querySelectorAll(".career-card")),this.isMobile=window.innerWidth<750,this.init();}return _createClass(e,[{key:"init",value:function(){this.isMobile&&(this.setupObserver(),window.addEventListener("resize",this.handleResize.bind(this)));}},{key:"setupObserver",value:function(){var e=this;this.observer=new IntersectionObserver((function(e){e.forEach((function(e){var i=e.target,t=parseInt(i.dataset.index,10),r=i.querySelector(".career-card__number");t>=1&&r&&(e.isIntersecting?r.classList.remove("whiten"):0===e.intersectionRatio&&r.classList.add("whiten"));}));}),{root:null,rootMargin:"-20% 0px -20% 0px",threshold:[0,.5]}),this.cards.forEach((function(i){e.observer.observe(i);}));}},{key:"handleResize",value:function(){var e=this.isMobile;this.isMobile=window.innerWidth<750,e&&!this.isMobile?this.cleanup():!e&&this.isMobile&&(this.initializeMobileState(),this.setupObserver());}},{key:"initializeMobileState",value:function(){this.cards.forEach((function(e){var i=parseInt(e.dataset.index,10),t=e.querySelector(".career-card__number");i>=1&&t&&t.classList.add("whiten");}));}},{key:"cleanup",value:function(){this.observer&&this.observer.disconnect(),this.cards.forEach((function(e){var i=e.querySelector(".career-card__number");i&&i.classList.remove("whiten");}));}}]),e}();document.addEventListener("DOMContentLoaded",(function(){document.querySelectorAll(".career-section__container").forEach((function(e){return new CareerSection(e)}));}));})();